<template>
  <div class="form-control">
    <div v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" @change="cambiarDatos($event)" class="form-control">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un tipo de sección</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} las secciónes</option>        
        <option v-for="(carrusel,index) in carruselesDeSeccion" :value="carrusel.ContenidoDeMicrositioId" :key="index">{{carrusel.TextoDelContenido}}</option>
      </select>      
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'
  

  export default {
    data() {
      return {
        enumeraciones,
        idDelModelo:null,
        carruselesDeSeccion: []
      }
    },
    props: {            
      parametros:Object,
      valorDefinido:Number,
      idDelInput:String,      
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      }
    },
    methods: {
       /**
       * Metodo para asignar la llave del elmento seleccionado del catalogo 008SeccionesDeLaPaginaWeb
       * @param {object} evento [evento emitido por el select]
       */
      cambiarDatos(evento){
        this.idDelModelo = evento.target.value;
        const valoresDelCatalogo =
        {
          llave: this.idDelInput,
          valor: evento.target.value
        }
        this.$store.dispatch("A_SICPO_Catalogo_015ContenidoMicrositio",valoresDelCatalogo);
         this.$emit("valorParaElPadre",evento);
      },
      /**
       * Metodo para lenar catalogo 008SeccionesDeLaPaginaWeb mediante el llamado de la API
       */
      cargarContenidoMicrositio: function() {
        const SERVIDOR = api.conexion;
        const METODO_API_AGREGAR = api.SICPO.catalogos.C014SeccionesMicrositios;
        let urlApi = SERVIDOR + METODO_API_AGREGAR;
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {};
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba;
        let peticionMetodoGetSeccionesDePaginasWebAPI = this.parametros;
        let peticionArchivos = false;
        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos);
        axios.post(urlApi, peticionMetodoGetSeccionesDePaginasWebAPI, headerPeticion)
                .then(respuesta => {            
                    if (respuesta.data.SiHayError) {
                        console.log(respuesta); 
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    } else {
                        this.carruselesDeSeccion = respuesta.data.SeccionesMicrositios[0].ContenidoDeMicrositio;
                    }
                })
                .catch(excepcion => {
                    console.log(excepcion);
                    comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
                }
        ) // axios.post
      }
    }, 
    mounted(){ 
      if(this.valorDefinido == undefined || this.valorDefinido == null){
      this.idDelModelo = this.tipo.Id;
      }
      else{
        this.idDelModelo = this.valorDefinido;
      }
        const valoresDelCatalogo = {
          llave: this.idDelInput,
          valor: this.idDelModelo
        }  
      },
    created(){
      this.cargarContenidoMicrositio();
    }
  }
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/SICPO/Catalogos/C015SelectContenidoMicrositio.vue